import { Tag } from 'primereact/tag';

import type { Template } from '../features/templates';

const TemplateActiveTag = ({ template }: { template: Template }) => {
  const { isActive } = template;

  return (
    <Tag
      severity={isActive ? 'success' : 'danger'}
      style={{ alignSelf: 'start' }}
      value={isActive ? 'Active' : 'Inactive'}
    />
  );
};

export default TemplateActiveTag;
